<template>
  <div class="extend-read">
    <div class="extend-content w1200">
      <div class="extend-left">
        <div v-if="$store.state.sceneClassName !== 'app'" class="extend-nav">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/news' }"
              >更多资讯</el-breadcrumb-item
            >
            <el-breadcrumb-item>企业培训</el-breadcrumb-item>
            <el-breadcrumb-item>文章详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="read-details">
          <!-- 文章标题 -->
          <h1 class="read-details-title">企业员工培训视频怎么录制</h1>
          <!-- 文章发布时间 -->
          <div class="read-details-time">2021-01-01 19:48:15</div>
          <!-- 文章正文 -->
          <div class="read-details-content">
            <p>
              <img
                :src="require('@/assets/images/newsDetail1.jpg')"
                alt="企业员工培训视频怎么录制"
              />
            </p>
            <p>
              一说到直播，很多人都觉得直播不就是用来卖东西的吗，不就是用来带货的吗？然而实际上，伴随着“直播时代”的来临，越来越多的行业，越来越多的企业加入到直播的大军之中，就连咱们的在线教育、企业员工培训，都已经开始使用这种新兴的直播方式了。咱们今天要来说说的，就是企业员工培训，你知道企业员工培训视频是怎么录制的吗？
            </p>
            <p><strong>第1种方式：手机拍摄</strong></p>
            <p>
              说到要录制视频拍摄视频，或许很多人首先会想到的就是手机吧，毕竟现如今的手机各方面配置都很不错，完全不亚于一个相机，不亚于一台摄像机，因此，用手机来录制视频，确实是一个不错的选择。只不过一次企业员工培训少则四五十分钟，多则可以达到好几个小时，如果需要用手机来拍摄的话，最好可以配备一个固定的工具，例如三脚架，要不然手动拿着拍摄还是很累的。
            </p>
            <p>
              除了拍摄的时候比较费劲之外，手机拍摄还有一个劣势也是十分显著的，那就是手机拍摄只能让老师入境，如果在培训的课程中需要分享到桌面或者是分享课件的话，就无法实现了。
            </p>
            <p><strong>第2种方式：录屏软件</strong></p>
            <p>
              说到录屏软件，相信大家一定不会陌生吧，特别是喜欢打游戏的朋友，经常都会用这种录屏软件来录制精彩的游戏视频，上传到网上分享，实际上这种录屏软件不仅可以录制游戏，也可以录制培训课程。这种录屏软件的优缺点刚好与手机拍摄相反，它能让我们实时分享课件内容分享桌面，但是却不能让老师入镜。
            </p>
            <p><strong>第3种方式：saas系统</strong></p>
            <p>
              最后一种可以将企业员工培训视频录制下来的方法，便是使用saas系统了，这也是目前在线教育、企业员工培训使用的最为频繁的工具之一，其中最为典型的，便有知链平台。
            </p>
            <p>
              相对于传统的手机、录屏软件，
              Saas系统可以为企业打造一个独立的管理平台，不仅可以录制企业员工培训视频，也可以选择在线直播的方式。
            </p>
            <p>
              平台拥有丰富的培训形式，不仅可以实时上传课件，分享桌面，还能实现多位讲师同屏，员工也可以在培训的过程中与讲师实时互动，在线提问。
            </p>
            <p>
              此外，平台还提供有海量的培训资料，涉及多个领域，涉及多个行业，企业无需费心寻找资料，直接在后台取用即可。
            </p>
          </div>
          <div
            v-if="$store.state.sceneClassName !== 'app'"
            class="nav-prev-next"
          >
            <div class="nav-item nav-prev">
              <div class="nav-item-label">
                <i class="el-icon-arrow-left nav-arrows"></i>
                上一篇
              </div>
              <div class="nav-item-title nonext">没有了</div>
            </div>
            <div class="nav-item nav-next">
              <a class="nav-item-label" href="/">
                <i class="el-icon-arrow-right nav-arrows"></i>
                下一篇
              </a>
              <div class="nav-item-title">
                <a href=""> 企业培训在线考试题库怎么搭建 </a>
              </div>
            </div>
          </div>
          <template v-else
            ><div class="read-details-tags">
              标签：
              <router-link to="/newsDetail">教育录播</router-link>
            </div>
            <div class="more-btn center">
              <router-link class="MediumBtnType3" to="/news"
                >更多延伸阅读</router-link
              >
            </div>
          </template>
          <!-- 相关文章 -->
          <div
            v-if="$store.state.sceneClassName !== 'app'"
            class="related-articles"
          >
            <div class="related-articles-title">
              <div class="extend-line"></div>
              <div class="hot-read-text">相关文章</div>
            </div>
            <div class="related-articles-boxs">
              <div class="related-articles-firstImg">
                <a href="/" class="related-articles-imgitem">
                  <img
                    :src="require('@/assets/images/newsDetail1.jpg')"
                    alt="企业培训在线考试题库怎么搭建"
                  />
                </a>
                <a href="/" class="related-articles-imgitem">
                  <img
                    :src="require('@/assets/images/newsDetail1.jpg')"
                    alt="做在线教育如何选择视频直播系统"
                  />
                </a>
              </div>
              <div class="related-articles-list">
                <a href="/" class="related-articles-item">
                  1.企业培训在线考试题库怎么搭建
                </a>
                <a href="/" class="related-articles-item">
                  2.做在线教育如何选择视频直播系统
                </a>
                <a href="/" class="related-articles-item">
                  3.企业高端培训直播平台怎么选？
                </a>
                <a href="/" class="related-articles-item"> 4.视频直播怎么做 </a>
                <a href="/" class="related-articles-item"> 5.怎么培训新员工 </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="$store.state.sceneClassName !== 'app'" class="extend-right">
        <div class="extend-right-title">
          <div class="extend-line"></div>
          <div class="hot-read-text">分类推荐</div>
        </div>
        <div class="type-list">
          <div class="type-item">
            <a href="/">小鹅学堂</a>
          </div>
          <div class="type-item">
            <a href="/">商业变现</a>
          </div>
          <div class="type-item">
            <a href="/">用户运营</a>
          </div>
          <div class="type-item">
            <a href="/">视频直播</a>
          </div>
          <div class="type-item">
            <a href="/">私域流量</a>
          </div>
          <div class="type-item">
            <a href="/">教育直播</a>
          </div>
          <div class="type-item">
            <a href="/">知识付费</a>
          </div>
          <div class="type-item">
            <a href="/">教育录播</a>
          </div>
          <div class="type-item">
            <a href="/">直播软件</a>
          </div>
          <div class="type-item">
            <a href="/">企业培训</a>
          </div>
          <div class="type-item">
            <a href="/">网校搭建</a>
          </div>
        </div>

        <div class="extend-right-title">
          <div class="extend-line"></div>
          <div class="hot-read-text">热门推荐</div>
        </div>
        <div class="hot-read-list">
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/">有什么免费教学直播软件好用？</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/">教师手机录课软件</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/">手机录课用什么APP？</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/">PPT录课时把人像录进去</a>
            </div>
          </div>
          <div class="hot-read-item">
            <div class="hot-read-date">08-04</div>
            <div class="hot-read-des">
              <a href="/">有没有什么在线直播教育平台推荐？</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.extend-read {
  .extend-content {
    margin: 0 auto;
    padding-bottom: 90px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .extend-content .extend-left {
    width: 768px;
  }
  .extend-content .extend-left .extend-nav {
    margin-top: 80px;
    padding: 24px 0 40px;
    line-height: 17px;
  }
  .extend-content .extend-left .extend-nav .extend-nav-a {
    color: #888;
    font-size: 12px;
  }
  .extend-content .extend-left .extend-nav .nav-arrows {
    width: 12px;
    height: 12px;
    position: relative;
    top: 2px;
  }
  .extend-content .extend-left .read-details .read-details-title {
    font-size: 36px;
    color: #353535;
    font-weight: 500;
    line-height: 50px;
    word-break: break-all;
  }
  .extend-content .extend-left .read-details .read-details-time {
    font-size: 14px;
    color: #b2b2b2;
    margin: 16px 0 39px;
  }
  .extend-content .extend-left .read-details .read-details-content {
    min-height: 200px;
    color: #353535;
    font-size: 16px;
    line-height: 30px;
  }
  .extend-content .extend-left .read-details .read-details-content p {
    margin-bottom: 24px;
    word-break: break-all;
  }
  .extend-content .extend-left .read-details .nav-prev-next {
    margin-bottom: 64px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-label {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 25px;
    font-size: 18px;
    font-weight: 700;
    color: #333;
    line-height: 25px;
    cursor: pointer;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-label:hover {
    color: #1472ff;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-label.nonext {
    cursor: not-allowed;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-label
    .nav-arrows {
    margin: 0 5px 0 0;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-title {
    margin-top: 8px;
    height: 22px;
    font-size: 16px;
    color: #333;
    line-height: 22px;
    width: 380px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-title:hover {
    color: #1472ff;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-item
    .nav-item-title.nonext {
    cursor: not-allowed;
    color: #c5c5c5;
  }
  .extend-content .extend-left .read-details .nav-prev-next .nav-next {
    text-align: right;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-next
    .nav-item-label {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
  }
  .extend-content
    .extend-left
    .read-details
    .nav-prev-next
    .nav-next
    .nav-item-label
    .nav-arrows {
    margin-left: 5px;
  }
  .extend-content .extend-left .read-details .related-articles-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 28px;
    margin-bottom: 16px;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles-title
    .extend-line {
    width: 4px;
    height: 22px;
    background: #1472ff;
    margin: 3px 8px 0 0;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles-title
    .hot-read-text {
    font-size: 20px;
    font-weight: 500;
    color: #353535;
  }
  .extend-content .extend-left .read-details .related-articles-boxs {
    margin-top: 24px;
  }
  .extend-content .extend-left .read-details .related-articles-boxs::after {
    display: block;
    content: '';
    clear: both;
    overflow: hidden;
    zoom: 1;
  }
  .extend-content .extend-left .read-details .related-articles-firstImg {
    margin-bottom: 24px;
  }
  .extend-content .extend-left .read-details .related-articles-firstImg::after {
    display: block;
    content: '';
    clear: both;
    overflow: hidden;
    zoom: 1;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles
    .related-articles-imgitem {
    display: block;
    float: left;
    width: 368px;
    height: 243px;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles
    .related-articles-imgitem:nth-of-type(2n + 1) {
    margin-right: 18px;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles
    .related-articles-imgitem
    img {
    width: 100%;
    height: 100%;
  }
  .extend-content .extend-left .read-details .related-articles-item {
    display: block;
    width: 365px;
    float: left;
    margin-bottom: 16px;
    height: 22px;
    font-size: 16px;
    font-weight: 700;
    color: #333;
    line-height: 22px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .extend-content .extend-left .read-details .related-articles-item:hover {
    color: #1472ff;
  }
  .extend-content
    .extend-left
    .read-details
    .related-articles-item:nth-of-type(2n + 1) {
    margin-right: 20px;
  }
  .extend-content .extend-left .read-details img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
  .extend-content .extend-left iframe {
    margin: 0 auto;
    display: block;
    height: 300px;
    width: 400px;
  }
  .extend-content .extend-right {
    width: 384px;
    margin-top: 160px;
  }
  .extend-content .extend-right .extend-right-title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 28px;
    margin-bottom: 16px;
  }
  .extend-content .extend-right .extend-right-title .extend-line {
    width: 4px;
    height: 22px;
    background: #1472ff;
    margin: 3px 8px 0 0;
  }
  .extend-content .extend-right .extend-right-title .hot-read-text {
    font-size: 20px;
    font-weight: 500;
    color: #353535;
  }
  .extend-content .extend-right .type-list {
    margin-bottom: 32px;
  }
  .extend-content .extend-right .type-list::after {
    display: block;
    content: '';
    clear: both;
    overflow: hidden;
    zoom: 1;
  }
  .extend-content .extend-right .type-list .type-item {
    float: left;
    width: 86px;
    height: 28px;
    line-height: 28px;
    border-radius: 2px;
    border: 1px solid #8fc7ff;
    background-color: #fff;
    margin-left: 8px;
    margin-bottom: 8px;
    text-align: center;
    overflow: hidden;
    font-size: 12px;
    color: #353535;
    cursor: pointer;
  }
  .extend-content .extend-right .hot-read-list .hot-read-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 16px;
  }
  .extend-content .extend-right .hot-read-list .hot-read-item .hot-read-date {
    width: 50px;
    color: #888;
    margin-right: 8px;
  }
  .extend-content .extend-right .hot-read-list .hot-read-item .hot-read-des {
    width: 332px;
    color: #353535;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
  }
  .extend-content
    .extend-right
    .hot-read-list
    .hot-read-item
    .hot-read-des:hover {
    color: #1472ff;
  }
}
.app .extend-read {
  padding-top: 1.04rem;
  .extend-content {
    padding-bottom: 1px;
    .extend-left {
      .read-details {
        padding: 0 0.32rem;
        .read-details-content {
          padding: 0 !important;
        }
        .read-details-title {
          padding: 0.8rem 0 0.16rem;
          font-weight: 500;
          font-size: 0.4rem;
          line-height: 0.56rem;
          word-break: break-all;
        }
        .read-details-time {
          font-size: 0.28rem;
          margin: 0 0 0.64rem;
        }
        .read-details-content {
          padding: 0.64rem 0;
          text-align: left;
          min-height: auto;
        }
      }
    }
    .read-details-tags {
      margin-bottom: 0.56rem;
      text-align: left;
      color: #888;
      a {
        color: inherit;
      }
    }
  }
  .more-btn {
    margin: 0 auto 1.28rem;
    .MediumBtnType3 {
      width: 4rem;
      height: 0.96rem;
      border-radius: 0.08rem;
      line-height: 0.96rem;
      font-size: 0.32rem;
      padding: 0;
    }
  }
}
</style>
